import { ReactNode, useEffect } from 'react';
import { mraTheme } from './theme';
import { GetBrandTheme } from '@leadflow/shared/theme/GetBrandTheme';

const ThemeProviderWrapper = ({ children }: { children: ReactNode }) => {
  useEffect(() => {
    document.documentElement.style.setProperty(
      '--Brand-Colors-primary-brand',
      mraTheme.typography.h1.color,
    );
  }, []);
  return <GetBrandTheme brandTheme={mraTheme}>{children}</GetBrandTheme>;
};

export default ThemeProviderWrapper;
